export default "__VITE_ASSET__BxuyqXQq__"